import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { CnReportDataService, CnReportData } from '../challenges_service/cn-report-data.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-cn-report-summary',
  templateUrl: './cn-report-summary.component.html',
  styleUrls: ['./cn-report-summary.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CnReportSummaryComponent implements OnInit, OnDestroy {
  data: CnReportData;
  loading = true;
  reportDate = new Date();
  env = environment;

  constructor(private reportDataService: CnReportDataService) {}

  async ngOnInit() {
    document.body.classList.add('cn-report-mode');
    this.data = await this.reportDataService.loadAllData();
    this.loading = false;
  }

  ngOnDestroy() {
    document.body.classList.remove('cn-report-mode');
  }

  print() {
    window.print();
  }

  hasActionPlan(): boolean {
    if (!this.data) return false;
    return this.data.short_content.some(i => i.what || i.who || i.when) ||
           this.data.mid_content.some(i => i.what || i.who || i.when) ||
           this.data.long_content.some(i => i.what || i.who || i.when);
  }

  hasNextContent(): boolean {
    if (!this.data) return false;
    return this.data.next_content.some(i => i && i !== '');
  }
}
